module.exports = __webpack_public_path__ + "static/media/html-css-and-javascript.d3daf495.png";